const reminder_types = [
    { reminderType: 1, description: 'Before Start of Shift' },
    { reminderType: 2, description: 'After Start of Shift' },
    { reminderType: 3, description: 'Before End of Shift' },
    { reminderType: 4, description: 'After End of Shift' }
]

export function getReminderTypeDescription(reminderType) {
    const reminderTypeData = reminder_types.find(x => x.reminderType == reminderType)
    return reminderTypeData ? reminderTypeData.description : ''
}